import {
  ArrowRight,
  Smartphone,
  Globe,
  Bluetooth,
  Wifi,
  Palette,
} from "lucide-react";
import { Link } from "react-router-dom";
import phone from "./../assets/phone.png";
import { useTranslation } from "../../../i18n";

export default function AppWebAppSection() {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-800 mb-6">
            <Smartphone className="w-4 h-4 mr-2" />
            <span className="text-sm font-medium">
              {t('bikeParking.appWebApp.experienceLabel')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('bikeParking.appWebApp.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('bikeParking.appWebApp.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center mb-16">
          {/* App Showcase */}
          <div className="lg:col-span-5 relative">
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-gradient-to-br from-indigo-300 to-purple-300 rounded-full opacity-30 blur-3xl"></div>
            <div className="relative z-10 flex justify-center">
              <div className="relative transform rotate-6 hover:rotate-0 transition-transform duration-500">
                {/* Real App Image */}
                <div className="relative w-[280px] border-0">
                  <img
                    src={phone}
                    alt="JUHUU Mobile App"
                    width={280}
                    height={600}
                    className="rounded-[32px]"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium">
                  {t('bikeParking.appWebApp.overlay')}
                </div>
              </div>
            </div>
          </div>

          {/* App Features */}
          <div className="lg:col-span-7">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="h-12 w-12 flex-shrink-0 mr-4 rounded-lg bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center">
                  <Smartphone className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{t('bikeParking.appWebApp.appSectionTitle')}</h3>
              </div>

              <p className="text-gray-600 mb-8">
                {t('bikeParking.appWebApp.appSectionDesc')}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-indigo-100 flex items-center justify-center mr-3">
                    <Palette className="h-5 w-5 text-indigo-600" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('bikeParking.appWebApp.internalWhiteTitle')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('bikeParking.appWebApp.internalWhiteDesc')}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center mr-3">
                    <Bluetooth className="h-5 w-5 text-purple-600" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('bikeParking.appWebApp.bluetoothTitle')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('bikeParking.appWebApp.bluetoothDesc')}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-indigo-100 flex items-center justify-center mr-3">
                    <Wifi className="h-5 w-5 text-indigo-600" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('bikeParking.appWebApp.iotTitle')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('bikeParking.appWebApp.iotDesc')}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center mr-3">
                    <Globe className="h-5 w-5 text-purple-600" />
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('bikeParking.appWebApp.externalWhiteTitle')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('bikeParking.appWebApp.externalWhiteDesc')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/app"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-md transition-colors"
                >
                  {t('bikeParking.appWebApp.moreApp')}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
                <Link
                  to="/webapp"
                  className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
                >
                  {t('bikeParking.appWebApp.exploreWeb')}
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* WebApp Section */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl overflow-hidden shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 md:p-12 text-white">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 text-white mb-6 backdrop-blur-sm">
                <Globe className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">{t('bikeParking.appWebApp.webLabel')}</span>
              </div>

              <h3 className="text-2xl md:text-3xl font-bold mb-6">
                {t('bikeParking.appWebApp.webTitle')}
              </h3>
              <p className="text-lg text-indigo-100 mb-6">
                {t('bikeParking.appWebApp.webDesc')}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
                  <h4 className="font-medium text-white mb-2">
                    {t('bikeParking.appWebApp.noInstallTitle')}
                  </h4>
                  <p className="text-sm text-indigo-100">
                    {t('bikeParking.appWebApp.noInstallDesc')}
                  </p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
                  <h4 className="font-medium text-white mb-2">
                    {t('bikeParking.appWebApp.responsiveTitle')}
                  </h4>
                  <p className="text-sm text-indigo-100">
                    {t('bikeParking.appWebApp.responsiveDesc')}
                  </p>
                </div>
              </div>

              <div className="mb-8">
                <h4 className="font-medium text-white mb-4">{t('bikeParking.appWebApp.availableVia')}</h4>
                <div className="flex flex-wrap gap-4 items-center">
                  {/* Real Browser Logos */}
                  <div className="bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center">
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Google_Chrome_icon_%28February_2022%29.svg-pxCvsR5Icu6gFYOAPS7QshHWSg6q19.png"
                      alt="Chrome"
                      width={32}
                      height={32}
                    />
                  </div>
                  <div className="bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center">
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Safari_browser_logo.svg-ZscEFrXvAG2w3teKf9Mo3cpK6JODY4.png"
                      alt="Safari"
                      width={32}
                      height={32}
                    />
                  </div>
                  <div className="bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center">
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Firefox_logo%2C_2019.svg-3kSvYG05KGZPFaWH1jY5pDAetgB1DH.png"
                      alt="Firefox"
                      width={32}
                      height={32}
                    />
                  </div>
                  <div className="bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center">
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Microsoft_Edge_logo_%282019%29-48F37FJ2geUgNNYPNyybNreIaT6gOx.png"
                      alt="Edge"
                      width={32}
                      height={32}
                    />
                  </div>
                  <div className="bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center">
                    <img
                      src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Opera_2015_icon.svg-hKqT4LdcSKz2Qban24gm6illNbt0rG.png"
                      alt="Opera"
                      width={32}
                      height={32}
                    />
                  </div>
                </div>
              </div>

              <Link
                to="/webapp"
                className="inline-flex items-center justify-center px-6 py-3 border border-white text-base font-medium rounded-md text-indigo-700 bg-white hover:bg-indigo-50 transition-colors shadow-md"
              >
                {t('bikeParking.appWebApp.testWebApp')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-l from-transparent to-indigo-600/50 lg:hidden"></div>
              <div className="h-full w-full relative">
                <iframe
                  src="https://app.juhuu.app/"
                  className="w-full h-full border-0"
                  title="JUHUU WebApp Live Demo"
                ></iframe>
                <div className="absolute -bottom-4 -right-4 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium">
                  {t('bikeParking.appWebApp.live')}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* App Store Badges */}
        <div className="mt-16 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-6">
            {t('bikeParking.appWebApp.downloadTitle')}
          </h3>
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="https://apps.apple.com/at/app/juhuu/id1603108125"
              className="transform hover:scale-105 transition-transform"
            >
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/apple.191e8c81d9bee01b4f9a-grn8UZYrVBtIPIcaeHRW6tVtebVaMz.webp"
                alt="Download on the App Store"
                width={160}
                height={53}
                className="h-12 w-auto"
              />
            </Link>

            <Link
              to="https://play.google.com/store/apps/details?id=com.juhuu_bikebox.juhuu&pli=1"
              className="transform hover:scale-105 transition-transform"
            >
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/google.52f09ed88134ad81db87-Ze921iU6VIxRIZdX3lnhNwbZIiWYV3.webp"
                alt="Get it on Google Play"
                width={160}
                height={53}
                className="h-12 w-auto"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
